import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import SectionTitle from './SectionTitle';

const { FiExternalLink } = FiIcons;
const VIDEO_URL = 'https://youtu.be/ymvtlTb0Wec';
const EMBED_URL = 'https://www.youtube-nocookie.com/embed/ymvtlTb0Wec';

export default function PromoVideo() {
  return (
    <div>
      <SectionTitle eyebrow="Video" title="Our promo video.">
        Share this short video with prospects before or after a call.
      </SectionTitle>
      <div className="mt-14 overflow-hidden rounded-3xl border border-slate-200 bg-slate-50">
        <iframe
          src={EMBED_URL}
          title="Jelly Local promo video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          loading="lazy"
          className="aspect-video w-full"
        />
      </div>
      <a
        href={VIDEO_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-5 inline-flex items-center gap-2 rounded-full border border-slate-200 px-5 py-3 text-sm font-semibold text-slate-700 hover:border-[#3fc0fa]"
      >
        Open video on YouTube <SafeIcon icon={FiExternalLink} />
      </a>
    </div>
  );
}